export const SITE = {
  domain: "https://abslpay.com",
  brand: "ABSLpay",
  legalName: "ABSL Payroll LLC",
  tagline: "CPA-reviewed payroll for all 50 states",
  phone: "+1-469-815-3491",
  phoneDisplay: "(469) 815-3491",
  email: "info@abslpay.com",
  city: "Frisco",
  region: "TX",
  founder: "Sreenivas Palla, CPA & CA",
  competitorChecked: "September 2026",
};

export const PLANS = {
  essentials: {
    key: "essentials", name: "Essentials", base: 39, per: 5,
    cname: "Gusto Simple", cbase: 49, cper: 6,
    fit: "Full-service payroll for small teams, in one state or many.",
    features: [
      "Unlimited payroll runs and direct deposit",
      "Federal, state and local tax filing and payments",
      "Multi-state payroll included at no extra cost",
      "W-2s and 1099s at year end",
      "New-hire reporting in every state",
      "Employee self-service portal and pay stubs",
      "Email support, answered within one business day",
    ],
  },
  plus: {
    key: "plus", name: "Plus", base: 69, per: 9,
    cname: "Gusto Plus", cbase: 80, cper: 12,
    fit: "For growing teams that want a CPA checking every run.",
    features: [
      "Everything in Essentials",
      "CPA review of each payroll before it runs",
      "Time tracking and PTO policies",
      "Garnishment and child-support processing",
      "Quarterly payroll-to-books reconciliation",
      "Phone support with a named payroll specialist",
    ],
  },
  complete: {
    key: "complete", name: "Complete", base: 149, per: 15,
    cname: "Gusto Premium", cbase: 180, cper: 22,
    fit: "Payroll, books and tax strategy handled by one CPA team.",
    features: [
      "Everything in Plus",
      "A dedicated CPA for your account",
      "Payroll journal entries posted to QuickBooks or Xero",
      "S-corp reasonable-compensation review",
      "Tip reporting and FICA tip credit (Form 8846) support",
      "IRS and state payroll notice handling included",
      "Annual review for WOTC and other payroll tax credits",
    ],
  },
};

export const CONTRACTOR = { base: 25, per: 5, cname: "Gusto Contractor Only", cbase: 35, cper: 6 };

export const money = (v) => (Number.isInteger(v) ? `$${v.toLocaleString()}` : `$${v.toLocaleString(undefined, { minimumFractionDigits: 2 })}`);

export const url = (path) => SITE.domain + path;

export const HOME_FAQ = [
  ["How much does ABSLpay payroll cost?",
    "Essentials is $39 a month plus $5 per person paid, Plus is $69 plus $9 per person, and Complete is $149 plus $15 per person. Multi-state payroll, tax filing and year-end W-2s and 1099s are included on every plan."],
  ["Do you run payroll in every state?",
    "Yes. We run payroll, register state tax accounts and file returns in all 50 states and Washington, DC, including employers with remote employees in several states."],
  ["How is ABSLpay different from Gusto or ADP?",
    "Our prices are published and lower than Gusto's matching plans, multi-state payroll is included on the entry plan, and on Plus and Complete a CPA reviews your payroll before it runs. You also get one team for payroll, bookkeeping and business tax."],
  ["Can I switch payroll providers in the middle of the year?",
    "Yes. We import your year-to-date wages and tax payments, check your first payroll against your old provider's figures, and file the full year's W-2s so your employees get one form."],
  ["What happens if I receive an IRS or state payroll tax notice?",
    "Send it to us. If the notice relates to a period we filed, we respond at no charge. Complete plan clients also get notice handling for earlier periods."],
];

export const orgSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["Organization", "ProfessionalService"],
  "@id": url("/#org"),
  name: SITE.brand,
  legalName: SITE.legalName,
  url: url("/"),
  telephone: SITE.phone,
  email: SITE.email,
  address: { "@type": "PostalAddress", addressLocality: SITE.city, addressRegion: SITE.region, addressCountry: "US" },
  priceRange: "$$",
  founder: { "@type": "Person", name: "Sreenivas Palla", hasCredential: ["Certified Public Accountant", "Chartered Accountant", "CISA"] },
  knowsAbout: ["Payroll", "Payroll tax filing", "Multi-state payroll", "Form 941", "Form 940", "W-2", "1099", "FICA tip credit"],
});

export const faqSchema = (qas) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: qas.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

export const breadcrumbSchema = (trail) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: trail.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: url(path) })),
});

export const offerCatalogSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Payroll services",
  name: "ABSLpay full-service payroll",
  provider: { "@id": url("/#org") },
  areaServed: { "@type": "Country", name: "United States" },
  hasOfferCatalog: {
    "@type": "OfferCatalog", name: "Payroll plans",
    itemListElement: Object.values(PLANS).map((p) => ({
      "@type": "Offer", name: `${p.name} payroll plan`, priceCurrency: "USD", price: p.base, url: url("/pricing"),
    })),
  },
});
